var _rect, _path, _path2, _rect2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFantomx = function SvgFantomx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 584 584",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 584,
    height: 584,
    rx: 292,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.336 165.659 419.34 506.663 507 419.004 165.995 78l-87.66 87.659Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.996 506.665 507 165.66l-87.659-87.659L78.337 419.005l87.659 87.66Z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 121,
    width: 342,
    height: 342,
    rx: 171,
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m306.188 255.665 43.36-25.293v50.586l-43.36-25.293Zm43.36 108.399-57.813 33.724-57.813-33.724v-59.017l57.813 33.724 57.813-33.724v59.017ZM233.922 230.372l43.36 25.293-43.36 25.293v-50.586Zm65.04 37.337 43.359 25.293-43.359 25.293v-50.586Zm-14.454 50.586-43.359-25.293 43.359-25.293v50.586Zm57.813-99.968-50.586 28.907-50.586-28.907 50.586-30.111 50.586 30.111Zm-122.852-4.818v157.782l72.266 40.95 72.266-40.95V213.509l-72.266-40.95-72.266 40.95Z",
    fill: "#13B5EC"
  })));
};
export default SvgFantomx;